// 《回到大荒》素材索引。
// 原始资源来自 Ammonia 工程（docs/头脑风暴 文案、assets 美术），已复制进本仓库 docs/dahuang 下，
// 保证官网构建自包含，不依赖外部工程路径。
import dahuangPromo1 from '../../../docs/dahuang/promo1.png';
import dahuangPromo2 from '../../../docs/dahuang/promo2.png';
import dahuangPromo3 from '../../../docs/dahuang/promo3.png';
import dahuangPromo4 from '../../../docs/dahuang/promo4.png';
import dahuangHero from '../../../docs/dahuang/hero_illustration.png';
import dahuangIcon from '../../../docs/dahuang/icon.png';
import dahuangCharGuQingYi from '../../../docs/dahuang/char_guqingyi.png';
import dahuangCharShenYaya from '../../../docs/dahuang/char_shenyaya.png';
import dahuangCharSuWan from '../../../docs/dahuang/char_suwan.png';
import npcGuQingYiHalf from '../../../docs/dahuang/npc_guqingyi_half.png';
import npcHanYanHalf from '../../../docs/dahuang/npc_hanyan_half.png';
import npcLeiHengHalf from '../../../docs/dahuang/npc_leiheng_half.png';
import npcLiShenHalf from '../../../docs/dahuang/npc_lishen_half.png';
import npcLinXiaoHalf from '../../../docs/dahuang/npc_linxiao_half.png';
import npcLiuDahuHalf from '../../../docs/dahuang/npc_liudahu_half.png';
import npcShenLingHalf from '../../../docs/dahuang/npc_shenling_half.png';
import npcShenYayaHalf from '../../../docs/dahuang/npc_shenyaya_half.png';
import npcSuWanHalf from '../../../docs/dahuang/npc_suwan_half.png';
import npcTieNiuHalf from '../../../docs/dahuang/npc_tieniu_half.png';
import npcWangLaoHanHalf from '../../../docs/dahuang/npc_wanglaohan_half.png';
import npcZhaoGuanJiaHalf from '../../../docs/dahuang/npc_zhaoguanjia_half.png';
// 配音（回到大荒 · 名场面代表句）。仅沈凌 / 顾清漪 / 沈丫丫三人有配音。
import voiceGuQingYi from '../../../docs/dahuang/voice/ch1_act01_wake_house_p03_guqingyi.mp3';
import voiceShenLing from '../../../docs/dahuang/voice/ch1_act02_river_roots_p05_shenling.mp3';
import voiceShenYaya from '../../../docs/dahuang/voice/ch1_act02_river_roots_p12_yaya.mp3';
// 剧情串讲精选 CG（竖屏）
import saga000 from '../../../docs/dahuang/saga/CG_000.png';
import saga001 from '../../../docs/dahuang/saga/CG_001.png';
import saga007 from '../../../docs/dahuang/saga/CG_007.png';
import saga008 from '../../../docs/dahuang/saga/CG_008.png';
import saga015 from '../../../docs/dahuang/saga/CG_015.png';
import saga017 from '../../../docs/dahuang/saga/CG_017.png';
import saga018 from '../../../docs/dahuang/saga/CG_018.png';
// 大荒 BGM 古风音乐（12 首 · 128k mp3，由 convert-dahuang-music.mjs 自 WAV 转换）
import musicChouTown from '../../../docs/dahuang/music/村头茶馆bgm.mp3';
import musicDreamBgm from '../../../docs/dahuang/music/大荒如梦bgm.mp3';
import musicDream from '../../../docs/dahuang/music/大荒如梦[沈凌].mp3';
import musicSnow from '../../../docs/dahuang/music/风雪归人[苏婉].mp3';
import musicHome from '../../../docs/dahuang/music/故乡bgm.mp3';
import musicSong from '../../../docs/dahuang/music/归大荒bgm.mp3';
import musicWasteland from '../../../docs/dahuang/music/荒原bgm.mp3';
import musicThunder from '../../../docs/dahuang/music/惊雷bgm.mp3';
import musicField from '../../../docs/dahuang/music/旷野bgm.mp3';
import musicLife from '../../../docs/dahuang/music/人间烟火[顾清漪].mp3';
import musicLifeBgm from '../../../docs/dahuang/music/人间烟火bgm.mp3';
import musicRugu from '../../../docs/dahuang/music/如故[沈凌+顾清漪].mp3';

const dahuangImageMap: Record<string, string> = {
  promo_1: dahuangPromo1,
  promo_2: dahuangPromo2,
  promo_3: dahuangPromo3,
  promo_4: dahuangPromo4,
  hero: dahuangHero,
  icon: dahuangIcon,
  char_guqingyi: dahuangCharGuQingYi,
  char_shenyaya: dahuangCharShenYaya,
  char_suwan: dahuangCharSuWan,
  npc_shenling_half: npcShenLingHalf,
  npc_guqingyi_half: npcGuQingYiHalf,
  npc_hanyan_half: npcHanYanHalf,
  npc_shenyaya_half: npcShenYayaHalf,
  npc_suwan_half: npcSuWanHalf,
  npc_linxiao_half: npcLinXiaoHalf,
  npc_liudahu_half: npcLiuDahuHalf,
  npc_zhaoguanjia_half: npcZhaoGuanJiaHalf,
  npc_wanglaohan_half: npcWangLaoHanHalf,
  npc_lishen_half: npcLiShenHalf,
  npc_tieniu_half: npcTieNiuHalf,
  npc_leiheng_half: npcLeiHengHalf,
};

// 配音索引（Vite import mp3 返回资源 URL）。voice id = 角色 id。
const dahuangVoiceMap: Record<string, string> = {
  shenling: voiceShenLing,
  guqingyi: voiceGuQingYi,
  shenyaya: voiceShenYaya,
};

// 剧情串讲 CG 索引。键名 saga_NNN 对应磁盘 CG_NNN.png。
const dahuangSagaMap: Record<string, string> = {
  saga_000: saga000,
  saga_001: saga001,
  saga_007: saga007,
  saga_008: saga008,
  saga_015: saga015,
  saga_017: saga017,
  saga_018: saga018,
};

export function getDahuangImage(key: string) {
  return dahuangImageMap[key.trim().toLowerCase()] ?? '';
}

export function getDahuangVoice(id: string) {
  return dahuangVoiceMap[id.trim().toLowerCase()] ?? '';
}

export function getCgSaga(key: string) {
  return dahuangSagaMap[key.trim().toLowerCase()] ?? '';
}

// 大荒 BGM 音乐索引（12 首）。id 见 dahuangConfig.dahuangSoundtrack。
const dahuangMusicMap: Record<string, string> = {
  choutown: musicChouTown,
  dream_bgm: musicDreamBgm,
  dream: musicDream,
  snow: musicSnow,
  home: musicHome,
  song: musicSong,
  wasteland: musicWasteland,
  thunder: musicThunder,
  field: musicField,
  life: musicLife,
  life_bgm: musicLifeBgm,
  rugu: musicRugu,
};

export function getDahuangMusic(id: string) {
  return dahuangMusicMap[id.trim().toLowerCase()] ?? '';
}
